export const extractParams = () => new Proxy(
  new URLSearchParams(window.location.search),
  {
    get: (searchParams, prop) => searchParams.get(prop),
  }
);

// for testing: http://localhost:3001/?locId=JVuQz53X81056ABVbYSx&apiKey=PE8WWeSAgh8Rnuht1FSixyWwTfvypF
// testing sales ai only : ?locId=znyOp3ej4q5WKsfdLbis&apiKey=jNB4DQ5w6puIn39XEAVbKIi7xnQj9r